import React from "react";
import { Navigate } from "react-router-dom";
// This component checks if the user is authenticated
const PrivateRoute = ({ children }) => {
  const authToken = localStorage.getItem("twinbox-admin-store");
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const user = JSON.parse(authToken);
  if (!isLoggedIn) {
    // if (!user?.token) {
    // Redirect to login if the user is not authenticated
    return <Navigate to="/login" />;
  }
  return children;
};
export default PrivateRoute;
